import { memo } from 'react';
import { Col, Form, Row } from 'react-bootstrap';

const Surgical = ({ selectedHistories, setSelectedHistories }) => {
  let { surgical } = selectedHistories || {};

  let defaultData = surgical || {
    lucs: '',
    lucsStatus: '',
    appendicectomy: '',
    appendicectomyStatus: '',
    cholecystectomy: '',
    cholecystectomyStatus: '',
    laparotomy: '',
    laparotomyStatus: '',
    laparoscopy: '',
    laparoscopyStatus: '',
    tah: '',
    tahStatus: '',
    ulso: '',
    ulsoStatus: '',
    dlso: '',
    dlsoStatus: '',
    others: '',
    othersStatus: '',
  };

  let selectedData = surgical || defaultData;

  const handleData = (fieldName, val, radioVal) => {
    console.log(fieldName, val, radioVal, 'ertret');
    switch (fieldName) {
      case 'lucsStatus':
      case 'appendicectomyStatus':
      case 'cholecystectomyStatus':
      case 'laparotomyStatus':
      case 'laparoscopyStatus':
      case 'tahStatus':
      case 'ulsoStatus':
      case 'dlsoStatus':
      case 'othersStatus':
        selectedData[fieldName] = val;
        break;
      default:
        selectedData[fieldName] = val;
    }

    selectedHistories['surgical'] = selectedData;

    console.log(selectedHistories, 'selectedHistories');
    setSelectedHistories({ ...selectedHistories });
  };

  return (
    <div className="surgical-history">
      <Row>
        <Col md={2} className="pt-1">
          LUCS:
        </Col>
        <Col md={4}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Form.Check
              type={`radio`}
              id={`luck-status-yes`}
              label={`Yes`}
              checked={selectedData?.lucsStatus === 'yes'}
              onChange={(e) =>
                handleData('lucsStatus', 'yes', e.target.checked)
              }
            />
            <Form.Check
              type={`radio`}
              id={`luck-status-no`}
              label={`No`}
              checked={selectedData?.lucsStatus === 'no'}
              onChange={(e) => handleData('lucsStatus', 'no', e.target.checked)}
            />
            <Form.Check
              type={`radio`}
              id={`luck-status-others`}
              label={`Others`}
              checked={selectedData?.lucsStatus === 'others'}
              onChange={(e) =>
                handleData('lucsStatus', 'others', e.target.checked)
              }
            />
          </div>
        </Col>
        <Col>
          <Form.Control
            size="sm"
            as="textarea"
            rows={1}
            placeholder="Add Note"
            defaultValue={selectedData?.lucs}
            onChange={(e) => handleData('lucs', e.target.value)}
          />
        </Col>
      </Row>
      <Row>
        <Col md={2} className="pt-1">
          Appendicectomy:
        </Col>
        <Col md={4}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Form.Check
              type={`radio`}
              id={`appendicectomy-yes`}
              label={`Yes`}
              checked={selectedData?.appendicectomyStatus === 'yes'}
              onChange={(e) =>
                handleData('appendicectomyStatus', 'yes', e.target.checked)
              }
            />
            <Form.Check
              type={`radio`}
              id={`appendicectomy-no`}
              label={`No`}
              checked={selectedData?.appendicectomyStatus === 'no'}
              onChange={(e) =>
                handleData('appendicectomyStatus', 'no', e.target.checked)
              }
            />
            <Form.Check
              type={`radio`}
              id={`appendicectomy-others`}
              label={`Others`}
              checked={selectedData?.appendicectomyStatus === 'others'}
              onChange={(e) =>
                handleData('appendicectomyStatus', 'others', e.target.checked)
              }
            />
          </div>
        </Col>
        <Col>
          <Form.Control
            size="sm"
            as="textarea"
            rows={1}
            placeholder="Add Note"
            defaultValue={selectedData?.appendicectomy}
            onChange={(e) => handleData('appendicectomy', e.target.value)}
          />
        </Col>
      </Row>
      <Row>
        <Col md={2} className="pt-1">
          Cholecystectomy:
        </Col>
        <Col md={4}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Form.Check
              type={`radio`}
              id={`cholecystectomyStatus-yes`}
              label={`Yes`}
              checked={selectedData?.cholecystectomyStatus === 'yes'}
              onChange={(e) =>
                handleData('cholecystectomyStatus', 'yes', e.target.checked)
              }
            />
            <Form.Check
              type={`radio`}
              id={`cholecystectomyStatus-no`}
              label={`No`}
              checked={selectedData?.cholecystectomyStatus === 'no'}
              onChange={(e) =>
                handleData('cholecystectomyStatus', 'no', e.target.checked)
              }
            />
            <Form.Check
              type={`radio`}
              id={`cholecystectomyStatus-others`}
              label={`Others`}
              checked={selectedData?.cholecystectomyStatus === 'others'}
              onChange={(e) =>
                handleData('cholecystectomyStatus', 'others', e.target.checked)
              }
            />
          </div>
        </Col>
        <Col>
          <Form.Control
            size="sm"
            as="textarea"
            rows={1}
            placeholder="Add Note"
            defaultValue={selectedData?.cholecystectomy}
            onChange={(e) => handleData('cholecystectomy', e.target.value)}
          />
        </Col>
      </Row>
      <Row>
        <Col md={2} className="pt-1">
          Laparotomy:
        </Col>
        <Col md={4}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Form.Check
              type={`radio`}
              id={`laparotomy-yes`}
              label={`Yes`}
              checked={selectedData?.laparotomyStatus === 'yes'}
              onChange={(e) =>
                handleData('laparotomyStatus', 'yes', e.target.checked)
              }
            />
            <Form.Check
              type={`radio`}
              id={`laparotomy-no`}
              label={`No`}
              checked={selectedData?.laparotomyStatus === 'no'}
              onChange={(e) =>
                handleData('laparotomyStatus', 'no', e.target.checked)
              }
            />
            <Form.Check
              type={`radio`}
              id={`laparotomy-others`}
              label={`Others`}
              checked={selectedData?.laparotomyStatus === 'others'}
              onChange={(e) =>
                handleData('laparotomyStatus', 'others', e.target.checked)
              }
            />
          </div>
        </Col>
        <Col>
          <Form.Control
            size="sm"
            as="textarea"
            rows={1}
            placeholder="Add Note"
            defaultValue={selectedData?.laparotomy}
            onChange={(e) => handleData('laparotomy', e.target.value)}
          />
        </Col>
      </Row>
      <Row>
        <Col md={2} className="pt-1">
          Laparoscopy:
        </Col>
        <Col md={4}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Form.Check
              type={`radio`}
              id={`laparoscopy-yes`}
              label={`Yes`}
              checked={selectedData?.laparoscopyStatus === 'yes'}
              onChange={(e) =>
                handleData('laparoscopyStatus', 'yes', e.target.checked)
              }
            />
            <Form.Check
              type={`radio`}
              id={`laparoscopy-no`}
              label={`No`}
              checked={selectedData?.laparoscopyStatus === 'no'}
              onChange={(e) =>
                handleData('laparoscopyStatus', 'no', e.target.checked)
              }
            />
            <Form.Check
              type={`radio`}
              id={`laparoscopy-others`}
              label={`Others`}
              checked={selectedData?.laparoscopyStatus === 'others'}
              onChange={(e) =>
                handleData('laparoscopyStatus', 'others', e.target.checked)
              }
            />
          </div>
        </Col>
        <Col>
          <Form.Control
            size="sm"
            as="textarea"
            rows={1}
            placeholder="Add Note"
            defaultValue={selectedData?.laparoscopy}
            onChange={(e) => handleData('laparoscopy', e.target.value)}
          />
        </Col>
      </Row>
      <Row>
        <Col md={2} className="pt-1">
          Total Abdominal History (TAH):
        </Col>
        <Col md={4}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Form.Check
              type={`radio`}
              id={`tah-yes`}
              label={`Yes`}
              checked={selectedData?.tahStatus === 'yes'}
              onChange={(e) => handleData('tahStatus', 'yes', e.target.checked)}
            />
            <Form.Check
              type={`radio`}
              id={`tah-no`}
              label={`No`}
              checked={selectedData?.tahStatus === 'no'}
              onChange={(e) => handleData('tahStatus', 'no', e.target.checked)}
            />
            <Form.Check
              type={`radio`}
              id={`tah-others`}
              label={`Others`}
              checked={selectedData?.tahStatus === 'others'}
              onChange={(e) =>
                handleData('tahStatus', 'others', e.target.checked)
              }
            />
          </div>
        </Col>
        <Col>
          <Form.Control
            size="sm"
            as="textarea"
            rows={1}
            placeholder="Add Note"
            defaultValue={selectedData?.tah}
            onChange={(e) => handleData('tah', e.target.value)}
          />
        </Col>
      </Row>
      <Row>
        <Col md={2} className="pt-1">
          TAH With BLSO:
        </Col>
        <Col md={4}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Form.Check
              type={`radio`}
              id={`ulso-yes`}
              label={`Yes`}
              checked={selectedData?.ulsoStatus === 'yes'}
              onChange={(e) =>
                handleData('ulsoStatus', 'yes', e.target.checked)
              }
            />
            <Form.Check
              type={`radio`}
              id={`ulso-no`}
              label={`No`}
              checked={selectedData?.ulsoStatus === 'no'}
              onChange={(e) => handleData('ulsoStatus', 'no', e.target.checked)}
            />
            <Form.Check
              type={`radio`}
              id={`ulso-others`}
              label={`Others`}
              checked={selectedData?.ulsoStatus === 'others'}
              onChange={(e) =>
                handleData('ulsoStatus', 'others', e.target.checked)
              }
            />
          </div>
        </Col>
        <Col>
          <Form.Control
            size="sm"
            as="textarea"
            rows={1}
            placeholder="Add Note"
            defaultValue={selectedData?.ulso}
            onChange={(e) => handleData('ulso', e.target.value)}
          />
        </Col>
      </Row>
      <Row>
        <Col md={2} className="pt-1">
          TLH With BLSO:
        </Col>
        <Col md={4}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Form.Check
              type={`radio`}
              id={`dlso-yes`}
              label={`Yes`}
              checked={selectedData?.dlsoStatus === 'yes'}
              onChange={(e) =>
                handleData('dlsoStatus', 'yes', e.target.checked)
              }
            />
            <Form.Check
              type={`radio`}
              id={`dlso-no`}
              label={`No`}
              checked={selectedData?.dlsoStatus === 'no'}
              onChange={(e) => handleData('dlsoStatus', 'no', e.target.checked)}
            />
            <Form.Check
              type={`radio`}
              id={`dlso-others`}
              label={`Others`}
              checked={selectedData?.dlsoStatus === 'others'}
              onChange={(e) =>
                handleData('dlsoStatus', 'others', e.target.checked)
              }
            />
          </div>
        </Col>
        <Col>
          <Form.Control
            size="sm"
            as="textarea"
            rows={1}
            placeholder="Add Note"
            defaultValue={selectedData?.dlso}
            onChange={(e) => handleData('dlso', e.target.value)}
          />
        </Col>
      </Row>
      <Row>
        <Col md={2} className="pt-1">
        Others:
        </Col>
        <Col md={4}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Form.Check
              type={`radio`}
              id={`others-yes`}
              label={`Yes`}
              checked={selectedData?.othersStatus === 'yes'}
              onChange={(e) =>
                handleData('othersStatus', 'yes', e.target.checked)
              }
            />
            <Form.Check
              type={`radio`}
              id={`others-no`}
              label={`No`}
              checked={selectedData?.othersStatus === 'no'}
              onChange={(e) => handleData('othersStatus', 'no', e.target.checked)}
            />
            <Form.Check
              type={`radio`}
              id={`others-others`}
              label={`Others`}
              checked={selectedData?.othersStatus === 'others'}
              onChange={(e) =>
                handleData('othersStatus', 'others', e.target.checked)
              }
            />
          </div>
        </Col>
        <Col>
          <Form.Control
            size="sm"
            as="textarea"
            rows={1}
            placeholder="Add Note"
            defaultValue={selectedData?.others}
            onChange={(e) => handleData('others', e.target.value)}
          />
        </Col>
      </Row>
    </div>
  );
};

export default memo(Surgical);
